var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKeyboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.667 9.33341V22.6667H5.33366V9.33341H26.667ZM26.667 6.66675H5.33366C3.86699 6.66675 2.68033 7.86675 2.68033 9.33341L2.66699 22.6667C2.66699 24.1334 3.86699 25.3334 5.33366 25.3334H26.667C28.1337 25.3334 29.3337 24.1334 29.3337 22.6667V9.33341C29.3337 7.86675 28.1337 6.66675 26.667 6.66675ZM14.667 10.6667H17.3337V13.3334H14.667V10.6667ZM14.667 14.6667H17.3337V17.3334H14.667V14.6667ZM10.667 10.6667H13.3337V13.3334H10.667V10.6667ZM10.667 14.6667H13.3337V17.3334H10.667V14.6667ZM6.66699 14.6667H9.33366V17.3334H6.66699V14.6667ZM6.66699 10.6667H9.33366V13.3334H6.66699V10.6667ZM10.667 18.6667H21.3337V21.3334H10.667V18.6667ZM18.667 14.6667H21.3337V17.3334H18.667V14.6667ZM18.667 10.6667H21.3337V13.3334H18.667V10.6667ZM22.667 14.6667H25.3337V17.3334H22.667V14.6667ZM22.667 10.6667H25.3337V13.3334H22.667V10.6667Z",
    fill: "#696969"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyboard);
export default __webpack_public_path__ + "static/media/keyboard.c3cfcae47812325e4e2cbec7d047ecfb.svg";
export { ForwardRef as ReactComponent };